import { render, staticRenderFns } from "./primary-kpi-scenario-step.vue?vue&type=template&id=34785e38"
import script from "./primary-kpi-scenario-step.vue?vue&type=script&lang=ts"
export * from "./primary-kpi-scenario-step.vue?vue&type=script&lang=ts"
import style0 from "./primary-kpi-scenario-step.vue?vue&type=style&index=0&id=34785e38&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34785e38')) {
      api.createRecord('34785e38', component.options)
    } else {
      api.reload('34785e38', component.options)
    }
    module.hot.accept("./primary-kpi-scenario-step.vue?vue&type=template&id=34785e38", function () {
      api.rerender('34785e38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/setup/scenario/steps/primary-kpi-scenario-step.vue"
export default component.exports